/** This file sets up the events that get projects working. */
import _ from "underscore";

import $ from "#jquery/jquery-with-scratchpad-plugins.js";
import {PROGRAM_STATUS} from "#scratchpad-shared-package/types.ts";
import LocalStore from "#shared-package/local-store.ts";

const bindEvents: any = _.once(function (ScratchpadUI, options) {
    $.extend(ScratchpadUI.dom, {
        // This is the one below the scratchpad created in scratchpad.jsx
        PROJECT_REQ_EVAL_BUTTON: ".request-eval-button",
        // This is the one actually created in projectfeedback-form
        PROJECT_EVAL_BUTTON: ".eval-button-container .kui-button",
    });

    $(ScratchpadUI).on({
        started: function (this: any, e) {
            if (!ScratchpadUI.scratchpad.isProject()) {
                return;
            }

            this.$el.on(
                "click",
                this.dom.PROJECT_REQ_EVAL_BUTTON,
                function (e) {
                    // Because we're technically looking for 2 classes, there could
                    // potentially be multiple matches, but we only know there will
                    // be one. This is less brittle than searching for the specific
                    // tag for a KUIButton, as that may (and has) changed.
                    $(ScratchpadUI.dom.PROJECT_EVAL_BUTTON)[0].click();
                },
            );

            const maybeShowProjectCompletion = function () {
                if (
                    ScratchpadUI.userScratchpad.get("challengeStatus") ===
                    PROGRAM_STATUS.PROJECT_PASS
                ) {
                    if (
                        !LocalStore.get(
                            ScratchpadUI.localStorage.SEEN_COMPLETED_PROJECT,
                        )
                    ) {
                        // The user is seeing that they completed this
                        // project for the first time
                        LocalStore.set(
                            ScratchpadUI.localStorage.SEEN_COMPLETED_PROJECT,
                            1,
                        );
                        options.onComplete?.();
                    }
                    ScratchpadUI.$el
                        .find(ScratchpadUI.dom.PROJECT_REQ_EVAL_BUTTON)
                        .hide();
                }
            };
            ScratchpadUI.userScratchpad.on(
                "change:challengeStatus",
                function (model, challengeStatus) {
                    maybeShowProjectCompletion();
                },
            );
            maybeShowProjectCompletion();
        },
    });
});

export default {
    bindEvents,
};
